{
  "title": "People",
  "lead": "Everyone here sees and logs for {{babies}}.",
  "members": "In the family",
  "you": "(you)",
  "someone": "Someone",
  "roles": { "owner": "Owner", "partner": "Partner", "caregiver": "Caregiver" },
  "rolesLower": { "owner": "owner", "partner": "partner", "caregiver": "caregiver" },
  "roleHelp": {
    "owner": "You can invite a partner or caregivers and manage everyone.",
    "partner": "You can invite caregivers. The owner manages roles.",
    "caregiver": "You can see the plan and log. Parents manage the family.",
    "partnerShort": "A partner sees everything, changes the routine and can invite caregivers.",
    "caregiverShort": "A caregiver sees the plan and logs, but can't change settings."
  },
  "manage": "Manage {{name}}",
  "roleLabel": "Role",
  "roleChanged": "{{name}} is now a {{role}}",
  "remove": "Remove {{name}} from the family",
  "removeShort": "Remove",
  "removeTitle": "Remove {{name}}?",
  "removeBody": "{{name}} will no longer see or log for {{babies}}. Their past logs stay.",
  "removed": "{{name}} removed",
  "invites": "Open invites",
  "inviteRow": "Invite a partner or caregiver",
  "inviteCaregiver": "Invite a caregiver",
  "inviteRowSub": "They see the same plan and log, free",
  "pending": "Pending",
  "sent": "sent {{date}}",
  "inviteTitle": "Invite to the family",
  "emailOptional": "Their email (optional)",
  "emailHint": "If you add it, only this email can use the link.",
  "createLink": "Create invite link",
  "linkReady": "Your {{role}} invite link is ready. Send it any way you like.",
  "share": "Share link",
  "copy": "Copy link",
  "copied": "Copied",
  "linkHint": "The link works once and expires on {{date}}.",
  "shareTitle": "Join us on Baby Plan",
  "shareText": "{{name}} invited you to Baby Plan to help with {{babies}}.",
  "anyoneWithLink": "Anyone with the link",
  "expires": "expires {{date}}",
  "revoke": "Cancel invite",
  "revokeTitle": "Cancel this invite?",
  "revokeBody": "The link will stop working.",
  "revoked": "Invite cancelled",
  "leave": "Leave this family",
  "leaveTitle": "Leave the family?",
  "leaveBody": "You'll no longer see or log for {{babies}}. You can join again with a new invite.",
  "invitedKicker": "You're invited",
  "invitedTitle": "{{name}} invited you to help with {{babies}}",
  "invitedAs": {
    "partner": "As a partner you'll see the plan, log sleep and feeds, and change the routine.",
    "caregiver": "As a caregiver you'll see the plan and log sleep and feeds."
  },
  "theirBaby": "their baby",
  "and": " and ",
  "signedInAs": "You're signed in as {{email}}.",
  "accept": "Join and see {{babies}}",
  "notNow": "Not now",
  "switchAccount": "Sign in with another email",
  "toFamily": "Go to your family",
  "toApp": "Open Baby Plan",
  "signupTitle": "Create your account",
  "emailBound": "Use the email this invite was sent to.",
  "name": "Your first name",
  "email": "Email",
  "password": "Password",
  "passwordHint": "At least 8 characters.",
  "signupSubmit": "Create account and join",
  "signInToAccept": "Sign in to accept",
  "haveAccount": "Already have an account?",
  "signIn": "Sign in",
  "link": {
    "invite_not_found": { "title": "This link doesn't work", "body": "Check that you opened the whole link, or ask for a new invite." },
    "invite_expired": { "title": "This invite has expired", "body": "Invites last 7 days. Ask for a new one." },
    "invite_revoked": { "title": "This invite was cancelled", "body": "Ask the person who sent it for a new one." },
    "invite_used": { "title": "This invite was already used", "body": "Each link works once. If it was you, just sign in." },
    "offline": { "title": "You're offline", "body": "Connect to the internet and open the link again." }
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "offline": "You're offline. Connect and try again.",
    "invite_email_mismatch": "This invite is for a different email. Sign in with the email it was sent to.",
    "already_member": "You're already in this family.",
    "cannot_accept_own_invite": "This is your own invite. Send the link to the person you want to invite.",
    "family_full": "This family already has the most members allowed.",
    "email_exists": "You already have a Baby Plan account. Sign in, then accept the invite.",
    "signup_rejected": "We couldn't create the account. Check the email and try again.",
    "crm_unavailable": "We can't create accounts right now. Try again in a minute.",
    "too_many_attempts": "Too many attempts. Wait a few minutes and try again.",
    "validation_error": "Check the fields and try again.",
    "too_many_invites": "You have too many open invites. Cancel one first.",
    "role_not_allowed": "You can't do that with your role.",
    "cannot_remove_owner": "The owner can't be removed.",
    "owner_cannot_leave": "The owner can't leave the family."
  }
}
